// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Toggle__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Toggle/Toggle.scss
 ** module id = 945
 ** module chunks = 1
 **/